import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import {
  useInvalidatePublicationThumbnailQuery,
  useUpdatePublicationThumbnailQuery,
} from "@/queries/query-publication-thumbnail";

type UploadPublicationThumbnailProps = {
  publicationId: string;
  imageUpload: Blob;
};

export const useUpdatePublicationThumbnail = () => {
  const update = useUpdatePublicationThumbnailQuery();
  const invalidate = useInvalidatePublicationThumbnailQuery();

  return useMutationWithErrorHandler<void, ApiError, UploadPublicationThumbnailProps>(
    async ({ publicationId, imageUpload }) => {
      const result = await getRanaApiV1().PublicationsApi.publicationThumbnailUpload({
        publicationId,
        imageUpload,
      });
      // If upload doesnt return a result, we want to invalidate the query so that it refetches the thumbnail
      if (result) {
        await update(publicationId, result);
      } else {
        await invalidate(publicationId);
      }
    }
  );
};
